import { render, staticRenderFns } from "./SupplyPointCommunicationsComponent.vue?vue&type=template&id=12b753c5"
import script from "./SupplyPointCommunicationsComponent.vue?vue&type=script&lang=js"
export * from "./SupplyPointCommunicationsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports